import 'angular:locale/data:de';
import './src/polyfills.ts';(globalThis.$localize ??= {}).locale = "de";
